<template>
	<div class="inquiry" style="width: 1200px; margin: auto">
		<!-- 面包屑导航 -->
		<el-breadcrumb class="breakcrumbHeader" separator-class="el-icon-arrow-right">
			<!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>限时折扣</el-breadcrumb-item> -->
			<el-breadcrumb-item style="cursor: pointer" @click.native="breadcrumbClick(item.id, index, item)"
				v-for="(item, index) in breadcrumbList" :key="item.id">{{ item.name }}</el-breadcrumb-item>
			<el-breadcrumb-item v-if="breadcrumbList.length == 1 ? true : false">所有</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="title">询价信息</div>
		<div class="formData">
			<div class="tableAdd">
				<el-table align="center" :data="list">
					<el-table-column label="序号" type="index" width="90px">
					</el-table-column>
					<el-table-column label="创建时间" prop="createTime">
					</el-table-column>
					<el-table-column prop="projectName" label="项目名称">
					</el-table-column>
					<el-table-column prop="companyName" label="产地"> </el-table-column>
					<el-table-column prop="contact" label="联系人"> </el-table-column>
					<el-table-column prop="contactPhone" label="联系电话" width="90px">
					</el-table-column>
					<el-table-column label="备注" width="260px" align="center" prop="remark">
					</el-table-column>
					<el-table-column label="状态" width="100px" align="center" prop="status">
						<template slot-scope="scope">
							<el-tag :type="scope.row.status == '1' ? 'success' : 'primary'"
								disable-transitions>{{scope.row.status==0?'待回复':scope.row.status==1?"已回复":scope.row.status==2?"已撤销":''}}</el-tag>
							<div class="operation">
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="280px" align="center" fixed="right">
						<template slot-scope="scope">
							<div class="operation">
								<div class="addShop" @click="getInfo(scope.row)">详情</div>
								<div class="addShop" @click="goEdit(scope.row)">编辑</div>
							</div>
						</template>
					</el-table-column>
				</el-table>
				  <!-- 分页功能 -->
				   <el-pagination
				             background
				             @size-change="handleSizeChange"
				             @current-change="handleCurrentChange"
				             :current-page="1"
				             :page-sizes="[10,20,30,50]"
				             layout="total, sizes, prev, pager, next, jumper"
				             :page.sync="pageNum"
				             :limit.sync="pageSize"
							 :total="total"
				           >
				           </el-pagination>
				 
				
			</div>
		</div>
		<el-dialog title="询价列表" :visible.sync="dialogVisible" width="60%" @close="dialogVisible = false">
			<el-table align="center" :data="infoList">
				<el-table-column label="序号" type="index" width="90px">
				</el-table-column>
				<el-table-column label="产品名称" prop="projectName"> </el-table-column>
				<el-table-column prop="createTime" label="创建时间"> </el-table-column>
				<el-table-column prop="price" label="单价"> </el-table-column>
				<el-table-column prop="number" label="数量"> </el-table-column>
				<el-table-column prop="count" label="小计"> </el-table-column>
				<el-table-column prop="arrivalTime" label="要求到货时间">
				</el-table-column>
				<el-table-column label="商品描述" width="260px" align="center" prop="remark">
				</el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>
<script>
	import {
		emptyEnquiryNum,
		enquiryNum,
		myEnquiryList,
		myEnquiryDetail,
		recommendFavorit,
		listDetails
	} from "@/api/xunyou";
	import axios from "axios";
	export default {
		data() {
			return {
				breadcrumbList: [{
					id: 1,
					name: "首页",
					url: "/"
				}, {
					id: 0,
					name: "所有",
					url: "/limitDiscounts"
				}], //面包屑数组
				dialogVisible: false,
				restaurants: [],
				state1: "",
				input: "",
				number: 0,
				tableData: [{
						date: "2016-05-02",
						name: "王小虎",
						content: "测试内容",
						id: 1,
						price: "200",
						num: 1,
						company: "",
						endTime: "",
						product: "",
						brand: "",
					},
					{
						date: "2016-05-02",
						name: "王小虎",
						content: "测试内容",
						id: 2,
						price: "120",
						num: 1,
						company: "",
						endTime: "",
						product: "",
						brand: "",
					},

				],
				value1: "",

				radio: "1",

				value: [],
				options: [],

				shopSelect: [],
				shopObj: {},
				formInline: {
					list: [{
						arrivalTime: "",
						brandId: 0,
						brandName: "",
						count: 0,
						fileName: "",
						number: 0,
						price: 0,
						projectId: 0,
						projectName: "",
						projectType: 0,
						skuId: 0,
						skuName: "",
						status: ""
					}, ],
				},
				list: [],
				infoList: [],
				userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
				pageNum:1,
				pageSize:'',
				total:10
			};
		},
		computed: {
			getCount() {
				return (row) => {
					return row.count * row.number;
				};
			},
		},
		mounted() {
			this.restaurants = this.loadAll();
			this.options = this.$store.state.getprovince;
		},
		created() {
			this.getShopSelect();
			this.getList();
		},
		methods: {
			// 查询我的询价审核未读数量
			enquiryNum() {
				console.log('查询数量');
				this.loading = true;
				let userId = this.userInfo.userId || '';

				getenquiryNum({
						userId: userId
					})
					.then((res) => {
						console.log('数量2');
						var dom = document.querySelector('.signEnquiry');
						console.log(dom);
						var numBox = document.createElement("p");
						numBox.style =
							"display:inline-block;;background: #ff6700 ;color:#fff;line-height: 23px;font-size: 12px;padding: 0 3px;border-radius: 16px;position: relative;left: 0px;top: -8px;min-width:16px;";
						var str = document.createTextNode(res.data);
						numBox.appendChild(str);
						if (res.data > 0) {
							dom.appendChild(numBox);
						}
					})
					.catch((err) => {
						this.editFormVisible = false;
						this.loading = false;
					});
			},
			// 我的询价审核已读
			emptyEnquiry(id) {
				console.log('数量');
				this.loading = true;
				let userId = this.userInfo.userId || '';
				emptyEnquiryNum({
						userId: userId,
						inquiryId: id
					})
					.then((res) => {
						console.log("数量", res);
						this.enquiryNum();
					})
					.catch((err) => {
						console.log("数量----4");
						this.editFormVisible = false;
						this.loading = false;
					});
			},
			// 面包屑点击事件
			breadcrumbClick(id, index, item) {
				if (id == 1) {
					// 说明是首页 文字
					this.$router.push("/");
				}

			},
			goEdit(row) {
				this.emptyEnquiry(row.id)
				this.$router.push(`/inquiry?id=${row.id}`)
			},
			//监听 pagesize 改变的事件
			    handleSizeChange(val) {
			      console.log(`每页 ${val} 条`);
			      this.pageSize = val;
			    },
			    //监听 页码值 改变的事件
			    handleCurrentChange(val) {
			      console.log(`当前页: ${val}`);
			      this.pageNum = val;
				  this.getList()
				  },
			getList() {
				console.log('列表');
				let userId = this.userInfo.userId || '';
				myEnquiryList({
						userId: userId,
						pageNum: this.pageNum,
						pageSize: 10
					})
					.then((res) => {
						const data = res.data;
						const list = data.rows.map((item) =>
							Object.assign({}, item.bxyInquiryUser, item.bxyInquiry)
						);
						this.list = list;
						console.log(this.list);
						this.total = res.data.total
					})
					.catch((err) => {
						this.editFormVisible = false;
						this.loading = false;
					});
					
					
					
					// 02
					
					// axios
					//   .get(
					//     `https://www.nays.com.cn/center/purchaser/inquiry/inquiry/list?userId=${userId}&pageNum=1&pageSize=10`
					//   )
					//   .then((res) => {
					//     const data = res.data;
					//     const list = data.data.rows.map((item) =>
					//       Object.assign({}, item.bxyInquiryUser, item.bxyInquiry)
					//     );
					//     this.list = list;
					// 		  console.log(this.list);
					//   });

			},
			getInfo(row) {
				this.dialogVisible = true
				const userInfo = JSON.parse(localStorage.getItem("userdata"));
				console.log(row);
				myEnquiryDetail({priceId:row.id})
				.then((res) => {
						const data = res.data;
						console.log(data);
						this.infoList = data.inquiryShopList;
					});
				this.emptyEnquiry(row.id)
			},
			postAddShop() {
				const data = {};
				const userInfo = JSON.parse(localStorage.getItem("userdata"));
				const inquiryUserDTO = JSON.parse(JSON.stringify(this.formInline));
				Reflect.deleteProperty(inquiryUserDTO, "list");
				inquiryUserDTO.userId = userInfo.userId;
				inquiryUserDTO.userName = userInfo.userName;
				const submitInquiryDTO = {
					areaId: userInfo.areaid,
					commodityList: this.formInline.list,
					userId: userInfo.userId,
					userName: userInfo.userName,
				};
				data.inquiryUserDTO = inquiryUserDTO;
				data.submitInquiryDTO = submitInquiryDTO;
				console.log(data);
				uploadContract(data).then((res) => {});
			},
			addShop() {
				this.formInline.list.push({
					arrivalTime: "",
					brandId: 0,
					brandName: "",
					count: 0,
					fileName: "",
					number: 0,
					price: 0,
					projectId: 0,
					projectName: "",
					projectType: 0,
					skuId: 0,
					skuName: "",
				});
			},
			getShopSelect() {
				const userInfo = JSON.parse(localStorage.getItem("userdata"));
				// axios({
				// 	method: "post",
				// 	url: "https://www.nays.com.cn/center/custom/xunyou/commodity/api/recommend/pcCommoditylist",
				// 	data: {
				// 		userId: userInfo.userId,
				// 		stype: 2,
				// 	},
				// 	transformRequest: [
				// 		function(data) {
				// 			let ret = "";
				// 			for (let it in data) {
				// 				ret +=
				// 					encodeURIComponent(it) +
				// 					"=" +
				// 					encodeURIComponent(data[it]) +
				// 					"&";
				// 			}
				// 			ret = ret.substring(0, ret.lastIndexOf("&"));
				// 			return ret;
				// 		},
				// 	],
				// })
				recommendFavorit({
						userId: userInfo.userId,
						stype: 2,
					})
				.then((res) => {
					this.shopSelect = res.data.rows;
					const obj = {};
					res.data.rows.forEach((item) => {
						obj[item.name] = item;
					});
					this.shopObj = obj;
				});
			},
			onChange(v, row) {
				console.log(v, row);
				const value = this.shopObj[v];
				console.log(this.shopObj);
				row.price = value.price;
				row.brandName = value.brandName;
				row.projectName - value.projectName
			},

		
			onSubmit() {
				console.log("submit!");
			},
			handleChange(value) {
				console.log(value);
			},
			querySearch(queryString, cb) {
				var restaurants = this.restaurants;
				var results = queryString ?
					restaurants.filter(this.createFilter(queryString)) :
					restaurants;
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			createFilter(queryString) {
				return (restaurant) => {
					return (
						restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
						0
					);
				};
			},
			loadAll() {
				return [{
						value: "三全鲜食（北新泾店）",
						address: "长宁区新渔路144号"
					},
					{
						value: "Hot honey 首尔炸鸡（仙霞路）",
						address: "上海市长宁区淞虹路661号",
					},
					{
						value: "新旺角茶餐厅",
						address: "上海市普陀区真北路988号创邑金沙谷6号楼113",
					},
					{
						value: "泷千家(天山西路店)",
						address: "天山西路438号"
					},
					{
						value: "胖仙女纸杯蛋糕（上海凌空店）",
						address: "上海市长宁区金钟路968号1幢18号楼一层商铺18-101",
					},
					{
						value: "贡茶",
						address: "上海市长宁区金钟路633号"
					},
					{
						value: "豪大大香鸡排超级奶爸",
						address: "上海市嘉定区曹安公路曹安路1685号",
					},
					{
						value: "茶芝兰（奶茶，手抓饼）",
						address: "上海市普陀区同普路1435号",
					},
					{
						value: "十二泷町",
						address: "上海市北翟路1444弄81号B幢-107"
					},
					{
						value: "星移浓缩咖啡",
						address: "上海市嘉定区新郁路817号"
					},
					{
						value: "阿姨奶茶/豪大大",
						address: "嘉定区曹安路1611号"
					},
					{
						value: "新麦甜四季甜品炸鸡",
						address: "嘉定区曹安公路2383弄55号"
					},
					{
						value: "Monica摩托主题咖啡店",
						address: "嘉定区江桥镇曹安公路2409号1F，2383弄62号1F",
					},
					{
						value: "浮生若茶（凌空soho店）",
						address: "上海长宁区金钟路968号9号楼地下一层",
					},
					{
						value: "NONO JUICE  鲜榨果汁",
						address: "上海市长宁区天山西路119号"
					},
					{
						value: "CoCo都可(北新泾店）",
						address: "上海市长宁区仙霞西路"
					},
					{
						value: "快乐柠檬（神州智慧店）",
						address: "上海市长宁区天山西路567号1层R117号店铺",
					},
					{
						value: "Merci Paul cafe",
						address: "上海市普陀区光复西路丹巴路28弄6号楼819",
					},
					{
						value: "猫山王（西郊百联店）",
						address: "上海市长宁区仙霞西路88号第一层G05-F01-1-306",
					},
					{
						value: "南拳妈妈龙虾盖浇饭",
						address: "普陀区金沙江路1699号鑫乐惠美食广场A13",
					},
				];
			},
			handleSelect(item) {
				console.log(item);
			},
			removeShop(val) {
				//   let newArr = {
				//     date: "",
				//     name: "",
				//     content: "",
				//     id: this.tableData[val].id,
				//     price: "",
				//     num: "",
				//     company: "",
				//     endTime: "",
				//     product: "",
				//     brand: "",
				//   };
				this.formInline.list.splice(val, 1);
				//   this.$set(this.tableData, val, newArr);
			},
			getImport() {
				this.dialogVisible = true;
			},
		},
	};
</script>
<style scoped lang="less">
	.inquiry {
		max-width: 1400px;
		margin: 0 auto;

		.title {
			height: 40px;
			line-height: 40px;
			margin: 0 auto;
			padding: 10px 5px 0;
			font-size: 16px;
			border-bottom: 1px solid #d3d3d3;
		}

		.formData {
			margin-top: 10px;
		}
	}

	/deep/ .el-input__inner {
		background-color: #fff;
	}

	/deep/ .project .el-input__inner {
		width: 450px;
	}

	/deep/ .name .el-input__inner {
		width: 383px;
	}

	/deep/ .explain {
		.el-textarea {
			width: 590px;
		}
	}

	/deep/ .user {
		display: flex;

		.el-input__inner {
			width: 220px;
		}

		.el-input__prefix {
			left: -39px;
		}
	}

	.tableAdd {
		margin: 0 auto;
	}

	.operation {
		display: flex;
		justify-content: space-around;
		font-size: 12px;

		div {
			padding: 5px 10px;
			border: 1px solid gainsboro;
			cursor: pointer;
		}

		.addShop {
			background-color: rgb(240, 131, 40);
			color: #fff;
		}
	}

	.commoditList {
		display: flex;
		font-size: 14px;
		cursor: pointer;

		.shop {
			width: 130px;
			text-align: right;
			padding: 0 12px 0 0;
		}

		.import {
			color: rgb(102, 183, 242);
		}

		.importPhoto {
			color: rgb(102, 183, 242);
			margin-left: 36px;
		}
	}

	.upload {
		.uploadFir {
			span {
				color: rgb(74, 144, 226);
				margin-left: 20px;
			}
		}

		.uploadSec {
			margin-top: 20px;

			span {
				display: inline-block;
				padding: 3px 8px;
				color: #fff;
				background-color: rgb(240, 131, 39);
				border-radius: 5px;
				margin: 0 20px;
			}

			em {
				font-weight: none;
				color: rgb(240, 131, 39);
				font-size: 12px;
			}
		}
	}

	.continue {
		display: flex;
		background-color: rgb(238, 238, 238);
		padding: 0 0 0 30px;
		height: 50px;
		align-items: center;
		justify-content: space-between;

		div {
			cursor: pointer;
		}

		.continueAdd {
			padding: 5px 10px;
			background: #fff;
		}

		.continueJoin {
			display: flex;
			align-items: center;

			height: 100%;

			.matching {
				color: rgb(131, 177, 230);
				margin-right: 50px;
			}

			.submit {
				height: 100%;
				background: rgb(240, 131, 39);
				line-height: 50px;
				padding: 0 30px;
				color: #fff;
			}
		}
	}
	
	
	.el-pagination{
		text-align: center;
		margin-top: 10px;
	}
	
	
</style>


// WEBPACK FOOTER //
// src/views/myprice/index.vue